import { useSyncExternalStore } from 'react';

let statusMap = {};

const listeners = new Set();

function emit() {
  listeners.forEach(listener => listener());
}

export function setCellStatus(key, status) {
  if (status === undefined) {
    const { [key]: _, ...rest } = statusMap;
    statusMap = rest;
  } else {
    statusMap = {
      ...statusMap,
      [key]: status,
    };
  }

  emit();
}

export function getCellStatus(key) {
  return statusMap[key];
}

export function useCellStatus(key) {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);

      return () => listeners.delete(listener);
    },
    () => statusMap[key],
  );
}
